export enum CompanyDocumentType {
  Filing = "filing",
  Transcript = "transcript",
}
